module.exports = __webpack_public_path__ + "img/tab-reward.04b39bf4.png";